// extracted by mini-css-extract-plugin
export default {"bounce":"ncAwkgwwz5wikUR8SMHQ"};